import { Popper } from '@material-ui/core';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import Spinner from '../../../components/ui/spinner';
import { get } from '../../../core/client';
import { useAppSelector } from '../../../store';
import { setFilter } from '../../../store/features/moments/momentsSlice';
import SimpleButton from '../home-feed/button';
import ButtonDot from '../home-feed/buttonDot';
import Card01 from '../home-feed/card01';
import FilterBox from '../home-feed/filter';

const Tabber = () => {
    const [tabValue, setTabValue] = useState<number>(0);
    const [personsOrTeamsOptions, setPersonsOrTeamsOptions] = useState<any>([]);
    const [searcInputParam, setSearcInputParam] = useState<any>('');
    const [personsOrTeamsId, setPersonsOrTeamsId] = useState<any>(null);
    const [open, setOpen] = useState<boolean>(false);

    const dispatch = useDispatch();
    const { eventList, filter, aside, tuttorialIndex, tutorial } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);

    const [debounceSearch] = useDebouncedCallback(() => getSearch(), 800);

    const getSearch = () => {
        if (searcInputParam !== '') {
            get<any>(`users/search?search=${searcInputParam}`).then(response => {
                const options = [];
                for (let i = 0; i < response.result.items.length; i++) {
                    const option = response.result.items[i];
                    options.push({
                        value: option?.userId,
                        label: option?.userId ? option.name + ' ' + option.surname : option.departmentName,
                        position: option?.userId && option.position + '@' + option.departmentName,
                        photo: option.photo,
                        isTeam: option.isTeam,
                        departmentId: option.departmentId,
                        departmentName: option.departmentName,
                    });
                }
                setPersonsOrTeamsOptions(options);
            });
        }
    };

    useEffect(() => {
        debounceSearch();
    }, [searcInputParam]);

    const CustomPopper = function (props) {
        return <Popper {...props} className="modal-04 " placement="bottom" />;
    };

    const handleTabberChange = (event, newValue: number) => {
        setTabValue(newValue);
        let val = 1;
        val = newValue === 1 ? 5 : val;
        val = newValue === 2 ? 10 : val;

        dispatch(
            setFilter({
                ...filter,
                userSearchType: val,
                search: personsOrTeamsId?.value ? personsOrTeamsId?.value : personsOrTeamsId?.departmentId,
            }),
        );
    };

    const clearSpecialDate = () => {
        dispatch(
            setFilter({
                ...filter,
                specialDate: null,
            }),
        );
    };

    const setInputChangeValue = (event, newInputValue) => {
        setSearcInputParam(newInputValue);
        if (newInputValue.length > 0) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    };

    const handleOpen = () => {
        if (personsOrTeamsOptions.length > 0) {
            setOpen(true);
        }
    };

    const handleChange = (_, val) => {
        setPersonsOrTeamsId(val);
        if (val) {
            dispatch(
                setFilter({
                    ...filter,
                    search: val?.value ? val?.value : val?.departmentId,
                    userSearchType: val ? 10 : filter.userSearchType,
                    isTeam: val?.isTeam,
                }),
            );
            if (val && val.label !== '') {
                setTabValue(2);
            }
        } else {
            setTabValue(0);
            dispatch(
                setFilter({
                    ...filter,
                    search: '',
                    specialDate: null,
                    timeType: 35,
                    userSearchType: 1,
                    isTeam: null,
                }),
            );
        }
    };

    return (
        <>
            {aside.departments.length > 1 && (
                <Tabs value={tabValue} onChange={handleTabberChange} aria-label="ant example" className="c-content-01">
                    <Tab label={words && words['WEB.myTeams']} className="c-content-01-A" />
                    <Tab label={words && words['WEB.relationTeams']} className="c-content-01-A" />
                    <Tab label={words && words['WEB.allTeams']} className="c-content-01-A" />
                </Tabs>
            )}

            <div className="c-content-02">
                <div className="autocomplete-01">
                    <Autocomplete
                        closeIcon={searcInputParam.length > 0 ? <CloseIcon /> : ''}
                        fullWidth={true}
                        open={open}
                        onOpen={handleOpen}
                        autoSelect
                        clearOnBlur={false}
                        onClose={() => setOpen(false)}
                        id="free-solo-2-demo-person-search"
                        noOptionsText={words && words['WEB.noPersonFounded']}
                        PopperComponent={CustomPopper}
                        //value={personsSearch}
                        onChange={(_, val: any) => handleChange(_, val)}
                        renderOption={option => (
                            <React.Fragment>
                                {!option.isTeam && (
                                    <img
                                        className="c-avatar"
                                        src={!option?.photo ? 'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg' : option.photo}
                                        alt={'https://khicindekocvar.blob.core.windows.net/prod/koc_icon_user.svg'}
                                    />
                                )}

                                <div className="c-person-wrapper">
                                    <span className="c-person-fullname">
                                        {option.label ? option.label : option.departmentName ? option.departmentName : ''}
                                    </span>
                                    <div className="c-person-position">{option.position}</div>
                                </div>
                            </React.Fragment>
                        )}
                        onInputChange={setInputChangeValue}
                        getOptionLabel={(option: any) => option && option.label && option.label}
                        options={personsOrTeamsOptions ? personsOrTeamsOptions : []}
                        className="autocomplete-person-team"
                        renderInput={params => (
                            <>
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder={words && words['WEB.searchPersonOrTeams']}
                                    className={'autocomplete-textfield'}
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <svg
                                                className="autocomplete-search-icon"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
                                                    stroke="#6C6C7D"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M21.0004 21L16.6504 16.65"
                                                    stroke="#6C6C7D"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        ),
                                    }}
                                />
                            </>
                        )}
                    />
                </div>
                <FilterBox />
            </div>

            <div className="c-content-03">
                <div className="c-content-03-A">
                    <SimpleButton />
                </div>
                {filter.specialDate && (
                    <button className="chip-01">
                        <span>{filter.specialDate?.toLocaleDateString('tr-TR')}</span>
                        <a className="close-chip" onClick={clearSpecialDate}>
                            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M9.99984 18.8332C14.6022 18.8332 18.3332 15.1022 18.3332 10.4998C18.3332 5.89746 14.6022 2.1665 9.99984 2.1665C5.39746 2.1665 1.6665 5.89746 1.6665 10.4998C1.6665 15.1022 5.39746 18.8332 9.99984 18.8332Z"
                                    stroke="#FFA775"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path d="M12.5 8L7.5 13" stroke="#FFA775" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M7.5 8L12.5 13" stroke="#FFA775" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    </button>
                )}
            </div>

            <div className={tuttorialIndex === 2 ? 'c-content-04 tutorial-active' : 'c-content-04'}>
                {eventList?.loading ? (
                    <Spinner />
                ) : eventList?.items?.length > 0 ? (
                    <>
                        {tuttorialIndex === 2 && (
                            <>
                                <div className={tuttorialIndex > 0 ? 'overlay-01 active' : 'overlay-01'}> </div>
                                <div className="card-tutorial">
                                    <ButtonDot description={tutorial?.items[1]?.description}></ButtonDot>
                                </div>
                            </>
                        )}
                        {eventList?.items?.map((item, index) => (
                            <Card01 key={'cart-01' + index} data={item} />
                        ))}
                    </>
                ) : (
                    <div className="c-content-04-A">
                        <span className="c-content-unit-01">{words && words['WEB.noPrivateMoments']}</span>
                    </div>
                )}
            </div>
        </>
    );
};

export default Tabber;
